import dvs from '../../assets/icons/DvsLogo.png';
import psicoterapia from '../../assets/icons/psicoterapia2.png';
import elementalpt from '../../assets/icons/elementalpt.png';
import playpt from '../../assets/icons/playpt.png';
import furiosapeds from '../../assets/icons/FuriosaPeds.png';
import minapeds from '../../assets/icons/MinaPeds.png';

const ProjetosData = [
    {
        title: "Psicoterapia Ativa",
        description: "Desenvolvi o site Psicoterapia Ativa para oferecer uma interface intuitiva e moderna, focada em promover os serviços de psicoterapia. O site apresenta uma navegação fácil, design responsivo e conteúdo informativo, visando proporcionar uma experiência agradável aos visitantes e destacar a importância da saúde mental.",
        image: psicoterapia ,
        link: "#",
    },
    {
        title: "Elemental  Wiki",
        description: "Esse é um projeto interno que desenvolvi para o PlayPT Priston Tale! O PlayPT Wiki é uma plataforma de conhecimento colaborativa, projetada para reunir informações, guias e recursos relacionados ao jogo. O objetivo é criar um espaço onde os jogadores possam compartilhar dicas, estratégias e detalhes sobre o universo do Priston Tale, promovendo a interação e o engajamento da comunidade.",
        image: elementalpt,
        link: "https://elementalpt.com.br/wiki/",
    },
    {
        title: "PlayPT Wiki",
        description: "Esse é um projeto interno que desenvolvi para o PlayPT Priston Tale! O PlayPT Wiki é uma plataforma de conhecimento colaborativa, projetada para reunir informações, guias e recursos relacionados ao jogo. O objetivo é criar um espaço onde os jogadores possam compartilhar dicas, estratégias e detalhes sobre o universo do Priston Tale, promovendo a interação e o engajamento da comunidade.",
        image: playpt,
        link: "https://playpt.com.br/wiki/",
    },
    {
        title: "Sistema de Ticket Discord",
        description: "Projeto desenvolvido para uso interno; O Sistema de Ticket Discord é uma aplicação que integra com a API do Discord para criar um sistema de suporte ao cliente. Ele permite que os usuários abram tickets de suporte diretamente no Discord, facilitando a comunicação entre clientes e equipe de suporte. Ideal para web lojas, cidades de RP de FiveM, RedM, guildas e entre outros.",
        image: dvs,
        link: "https://discord.gg/7Bax8Dpw4w",
    },
    {
        title: "Furiosa Peds",
        description: "Projeto desenvolvido para uso interno; O Sistema de Ticket Discord é uma aplicação que integra com a API do Discord para criar um sistema de suporte ao cliente. Ele permite que os usuários abram tickets de suporte diretamente no Discord, facilitando a comunicação entre clientes e equipe de suporte. Ideal para web lojas, cidades de RP de FiveM, RedM, guildas e entre outros.",
        image: furiosapeds,
        link: "https://discord.gg/7Bax8Dpw4w",
    },
    {
        title: "Mina Peds",
        description: "Projeto desenvolvido para uso interno; O Sistema de Ticket Discord é uma aplicação que integra com a API do Discord para criar um sistema de suporte ao cliente. Ele permite que os usuários abram tickets de suporte diretamente no Discord, facilitando a comunicação entre clientes e equipe de suporte. Ideal para web lojas, cidades de RP de FiveM, RedM, guildas e entre outros.",
        image: minapeds,
        link: "https://discord.gg/7Bax8Dpw4w",
    },
]

export default ProjetosData;